(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MPB_complementary-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.MPBComp) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function num(v, f) { var n = parseInt(v, 10); return isNaN(n) ? f : n; }
  function eur(c) {
    var v = (Number(c) || 0) / 100;
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(v); }
    catch (e) { return v.toFixed(2).replace('.', ',') + ' €'; }
  }

  function fetchSlides(url) {
    if (!url) return Promise.resolve([]);
    var ac = window.AbortController ? new AbortController() : null;
    var t = ac ? setTimeout(function () { ac.abort(); }, 4000) : 0;
    return fetch(url, { credentials: 'same-origin', signal: ac ? ac.signal : undefined })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h) {
        clearTimeout(t);
        if (!h) return [];
        var d = new DOMParser().parseFromString(h, 'text/html');
        return [].slice.call(d.querySelectorAll('[data-mpb-rec] .mpb-comp-slide'));
      })
      .catch(function () { clearTimeout(t); return []; });
  }

  function rule(i) { return { min: Math.max(1, num(i.min, 1)), step: Math.max(1, num(i.step, 1)), max: num(i.max, 0) || null }; }
  function setQty(i, v) {
    if (!i) return 1;
    var r = rule(i);
    v = (v === undefined || isNaN(v)) ? num(i.value, r.min) : v;
    v = Math.max(r.min, v);
    v = r.min + Math.round((v - r.min) / r.step) * r.step;
    if (r.max) v = Math.min(v, r.max);
    i.value = v;
    return v;
  }

  function openCart() {
    if (window.jQuery) { try { window.jQuery('body').trigger('update:miniCart'); } catch (e) {} }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    setTimeout(function () {
      var t = document.querySelector('.push_side[data-id="#js_cart_popup"],[data-id="#js_cart_popup"],[href="#js_cart_popup"],[aria-controls="js_cart_popup"]');
      if (t) t.click();
    }, 200);
  }

  function add(card, btn) {
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    if (card.dataset.request === 'true') { window.location.href = card.dataset.productUrl; return; }
    var id = Number(card.querySelector('[data-mpb-variant]').value);
    var q = setQty(card.querySelector('[data-mpb-qty]'));
    if (!id) return;
    var label = btn.querySelector('[data-mpb-cart-text]'), orig = label.textContent;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    label.textContent = 'Wird hinzugefügt …';
    fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: q }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { label.textContent = '✓ Hinzugefügt'; openCart(); })
      .catch(function (e) { label.textContent = (e && e.description) || 'Erneut versuchen'; })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        setTimeout(function () { label.textContent = orig; }, 1800);
      });
  }

  function variant(sel) {
    var card = sel.closest('[data-mpb-comp-card]'), o = sel.options[sel.selectedIndex];
    if (!card || !o) return;
    var price = Number(o.dataset.price || 0), av = o.dataset.available === 'true', req = price >= 100000;
    card.querySelector('[data-mpb-variant]').value = o.value;
    card.querySelector('[data-mpb-net]').textContent = eur(Math.round(price * 100 / 119));
    card.querySelector('[data-mpb-gross]').textContent = eur(price);
    var q = card.querySelector('[data-mpb-qty]');
    if (q) {
      q.min = o.dataset.min || 1;
      q.step = o.dataset.step || 1;
      if (o.dataset.max) q.max = o.dataset.max; else q.removeAttribute('max');
      q.value = q.min;
    }
    card.dataset.request = String(req);
    card.classList.toggle('is-unavailable', !av || req);
    var s = card.querySelector('[data-mpb-status]');
    s.className = 'mpb-comp-status mpb-comp-status--' + (req ? 'request' : av ? 'available' : 'sold');
    s.textContent = req ? 'Lieferung möglich' : av ? 'Sofort lieferbar' : 'Im Zulauf';
    var b = card.querySelector('[data-mpb-cart]');
    b.disabled = !av && !req;
    b.classList.toggle('is-request', req);
    b.querySelector('[data-mpb-cart-text]').textContent = req ? 'Angebot anfragen' : av ? 'Hinzufügen' : 'Im Zulauf';
  }

  function bind(root) {
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mpb-minus],[data-mpb-plus],[data-mpb-cart]');
      if (!t || !root.contains(t)) return;
      var card = t.closest('[data-mpb-comp-card]');
      if (!card) return;
      e.preventDefault();
      if (t.hasAttribute('data-mpb-cart')) { add(card, t); return; }
      var i = card.querySelector('[data-mpb-qty]'), r = rule(i);
      setQty(i, setQty(i) + (t.hasAttribute('data-mpb-plus') ? r.step : -r.step));
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-mpb-qty]')) setQty(e.target);
      else if (e.target.matches('[data-mpb-select]')) variant(e.target);
    });
  }

  function carousel(root) {
    var vp = root.querySelector('[data-mpb-viewport]'), track = root.querySelector('[data-mpb-track]');
    var prev = root.querySelector('[data-mpb-prev]'), next = root.querySelector('[data-mpb-next]'), dots = root.querySelector('[data-mpb-dots]');
    var scrollBy = Math.max(1, num(root.dataset.scroll, 1));
    var speed = reduce ? 0 : Math.max(0, num(root.dataset.speed, 450));
    var infinite = root.dataset.infinite === 'true';
    var auto = root.dataset.autoplay === 'true' && !reduce;
    var interval = Math.max(2000, num(root.dataset.interval, 5000));
    var m = { pages: 1, page: 0, size: 1, max: 0 }, pause = {}, raf = 0, anim = 0;

    function animateTo(left) {
      cancelAnimationFrame(anim);
      var start = vp.scrollLeft, d = left - start;
      if (!speed || Math.abs(d) < 1) { vp.scrollLeft = left; return; }
      vp.style.scrollSnapType = 'none';
      var t0 = null;
      function f(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / speed);
        var e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        vp.scrollLeft = start + d * e;
        if (p < 1) anim = requestAnimationFrame(f);
        else vp.style.scrollSnapType = '';
      }
      anim = requestAnimationFrame(f);
    }
    function timer() {
      clearInterval(root._mpbTimer);
      root._mpbTimer = null;
      if (!auto || m.pages < 2) return;
      for (var k in pause) if (pause[k]) return;
      root._mpbTimer = setInterval(function () { go(m.page + 1, true); }, interval);
    }
    function cur() { return (m.pages > 1 && vp.scrollLeft >= m.max - 2) ? m.pages - 1 : Math.round(vp.scrollLeft / m.size); }
    function go(i, wrap) {
      if (infinite || wrap) i = (i + m.pages) % m.pages;
      else i = Math.max(0, Math.min(i, m.pages - 1));
      animateTo(Math.min(i * m.size, m.max));
    }
    function buildDots() {
      if (!dots) return;
      dots.innerHTML = '';
      dots.hidden = m.pages < 2;
      for (var i = 0; i < m.pages; i++) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'mpb-comp__dot'; d.dataset.i = i;
        d.setAttribute('aria-label', 'Position ' + (i + 1));
        dots.appendChild(d);
      }
    }
    function sync() {
      m.page = cur();
      var multi = m.pages > 1;
      if (prev) { prev.hidden = !multi; prev.disabled = !infinite && m.page === 0; }
      if (next) { next.hidden = !multi; next.disabled = !infinite && m.page >= m.pages - 1; }
      if (dots) [].forEach.call(dots.children, function (d, i) {
        d.classList.toggle('is-active', i === m.page);
        d.setAttribute('aria-current', i === m.page ? 'true' : 'false');
      });
      timer();
    }
    function measure() {
      var s = track.firstElementChild;
      if (!s) return;
      var g = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = s.getBoundingClientRect().width + g;
      var per = Math.max(1, Math.round((vp.clientWidth + g) / step));
      m.size = Math.min(scrollBy, per) * step;
      m.max = Math.max(0, vp.scrollWidth - vp.clientWidth);
      var pages = m.max > 2 ? Math.ceil(m.max / m.size - 0.02) + 1 : 1;
      if (pages !== m.pages || (dots && dots.childElementCount !== pages)) { m.pages = pages; buildDots(); }
      sync();
    }
    function p(k, v) { return function () { pause[k] = v; timer(); }; }

    if (prev) prev.addEventListener('click', function () { go(m.page - 1); });
    if (next) next.addEventListener('click', function () { go(m.page + 1); });
    if (dots) dots.addEventListener('click', function (e) { var d = e.target.closest('.mpb-comp__dot'); if (d) go(+d.dataset.i); });
    vp.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    root.addEventListener('mouseenter', p('h', 1));
    root.addEventListener('mouseleave', p('h', 0));
    root.addEventListener('focusin', p('f', 1));
    root.addEventListener('focusout', p('f', 0));
    vp.addEventListener('touchstart', p('t', 1), { passive: true });
    document.addEventListener('visibilitychange', function () { pause.d = document.hidden; timer(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { pause.v = !es[0].isIntersecting; timer(); }).observe(root);
    if ('ResizeObserver' in window) new ResizeObserver(function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(measure); }).observe(vp);
    else window.addEventListener('resize', measure);
    measure();
  }

  function hydrate(root) {
    var track = root.querySelector('[data-mpb-track]');
    var max = num(root.dataset.max, 10);
    var tpl = root.querySelector('template[data-mpb-fallback]');
    var fb = tpl ? [].slice.call(tpl.content.querySelectorAll('.mpb-comp-slide')) : [];

    Promise.all([fetchSlides(root.dataset.cUrl), fetchSlides(root.dataset.rUrl)]).then(function (r) {
      var seen = {}, frag = document.createDocumentFragment(), n = 0;
      seen[root.dataset.productId] = 1;
      [r[0], r[1], fb].forEach(function (list) {
        list.forEach(function (node) {
          var id = node.getAttribute('data-product-id');
          if (n >= max || !id || seen[id]) return;
          seen[id] = 1;
          frag.appendChild(document.importNode(node, true));
          n++;
        });
      });
      if (!n) { root.hidden = true; return; }
      track.replaceChildren(frag);
      track.classList.remove('is-loading');
      track.setAttribute('aria-busy', 'false');
      bind(root);
      carousel(root);
    });
  }

  function boot(root) {
    if (root._mpb) return;
    root._mpb = 1;
    var run = function () { hydrate(root); };
    if ((window.Shopify && Shopify.designMode) || !('IntersectionObserver' in window)) { run(); return; }
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { io.disconnect(); run(); }
    }, { rootMargin: '600px 0px' });
    io.observe(root);
  }

  window.MPBComp = function (scope) { (scope || document).querySelectorAll('[data-mpb-comp]').forEach(boot); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.MPBComp(); });
  else window.MPBComp();
  document.addEventListener('shopify:section:load', function (e) { window.MPBComp(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-mpb-comp]').forEach(function (r) { clearInterval(r._mpbTimer); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
